// Explicit key constants to avoid hardcoded strings at call sites.
// Use these with setTrackingData(); the event name sent to Amplitude is the lowercase snake_case value.
export const TRACK_EVENT_KEYS = {
    // Page views
    COACHING_PAGE_VIEWED: 'coaching_page_viewed',
    SCHEDULING_FORM_VIEWED: 'scheduling_form_viewed',
    CONFIRMATION_PAGE_VIEWED: 'confirmation_page_viewed',
    CONFIRMATION_PAGE_V2_VIEWED: 'confirmation_page_v2_viewed',
    CONFIRMATION_MENTAL_HEALTH_VIEWED: 'confirmation_mental_health_viewed',
    SESSION_DETAILS_VIEWED: 'session_details_viewed',

    // Appointment actions
    APPOINTMENT_SCHEDULED: 'appointment_scheduled',
    SCHEDULE_BUTTON_CLICKED: 'schedule_button_clicked',

    // User interactions
    PHONE_NUMBER_CHANGED: 'phone_number_changed',
    TIMEZONE_CHANGED: 'timezone_changed',
    DATE_SELECTED: 'date_selected',
    TIME_SELECTED: 'time_selected',
    COACH_SELECTED: 'coach_selected',
    LANGUAGE_CHANGED: 'language_changed',
    PAST_SESSION_CHANGED: 'past_session_changed',
    ANY_COACH_SELECTED: 'any_coach_selected',
    DIFFERENT_COACH_SELECTED: 'different_coach_selected',

    // Authentication
    SIGN_IN_CLICKED: 'sign_in_clicked',
    LOGIN_SUCCESS: 'login_success',
    LOGIN_FAILED: 'login_failed',

    // Errors
    SCHEDULING_ERROR: 'scheduling_error',
    ALREADY_BOOKED_ERROR: 'already_booked_error',

    // Session events
    SESSION_START: 'session_start',

    // Property names for event data
    PhoneNumber: 'updated_phone_number',
    SelectedTimeZone: 'selected_timezone',
    SelectedDate: 'selected_date',
    SelectedTime: 'selected_time',
    TimeValue: 'time_value',
    HasNotes: 'has_notes',
    IsSharedCoaching: 'is_shared_coaching',
    CalendarId: 'calendar_id',
    StartDate: 'start_date',
    StartTime: 'start_time',
    Timezone: 'timezone',
    CoachName: 'coach_name',
    ErrorDetails: 'error_details',
    SelectedLanguage: 'selected_language',
    CoachId: 'coach_id',
    IsPreviousCoach: 'is_previous_coach',
    HasPastSession: 'has_past_session',
    ErrorCode: 'error_code',
};
